import script from "./RadioDays.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioDays.vue?vue&type=script&setup=true&lang=js"

import "./RadioDays.vue?vue&type=style&index=0&id=229c348e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229c348e"]])

export default __exports__